export default __webpack_public_path__ + "static/media/mw1.a9e66c9c.png";